import { useMemo } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'

import { useAppSelector } from '@user/store/hooks'
import { arrangeColumns, orderByToSortModel } from '@user/components/xGrid'
import {
  selectActivitySummaryColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'

import { useFetchData } from './useFetchData'
import { columns as defaultColumns } from '../columns'
import { useActivitySummaryContext } from '../../../context'

export function useData() {
  useFetchData()

  const apiRef = useGridApiRef()

  const [state] = useActivitySummaryContext()

  const prefsLoading = useLoadListViewPreferencesOnce()

  const {
    filterSet: { orderBy },
    tableState: { rows, totalRows, loading, paginationState },
  } = state

  const columnOrder = useAppSelector(selectActivitySummaryColumnOrder)

  const sortModel = useMemo(() => orderByToSortModel(orderBy), [orderBy])

  const [columns, columnVisibility] = useMemo(
    () => arrangeColumns(columnOrder, defaultColumns(), []),
    [columnOrder],
  )

  return {
    rows,
    apiRef,
    columns,
    loading,
    paginationState,
    sortModel,
    prefsLoading,
    columnVisibility,
    rowCount: totalRows,
  }
}
